import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../contexts/AuthContext";
import { formatErr } from "../lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      const r = await login(form.email, form.password);
      if (r.otp) { toast.error("Use staff login for OTP-protected accounts"); nav("/staff/login"); return; }
      toast.success("Welcome back"); nav("/");
    } catch (e) { toast.error(formatErr(e)); } finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen bg-white grid md:grid-cols-2">
      <div className="hidden md:block relative">
        <img src="https://images.pexels.com/photos/15019857/pexels-photo-15019857.jpeg?w=1200" alt="" className="w-full h-full object-cover"/>
      </div>
      <div className="flex items-center justify-center p-10 md:p-20">
        <div className="w-full max-w-sm">
          <Link to="/" className="overline mb-8 block">← Back to Luxe Watches</Link>
          <h1 className="font-display text-4xl text-dark mb-3">Sign in</h1>
          <p className="text-sm text-gray-500 mb-10">Welcome back to your private boutique.</p>
          <form onSubmit={submit} className="space-y-7">
            <input data-testid="login-email" type="email" required placeholder="Email" className="input-luxe" value={form.email} onChange={(e)=>setForm({...form, email:e.target.value})}/>
            <input data-testid="login-password" type="password" required placeholder="Password" className="input-luxe" value={form.password} onChange={(e)=>setForm({...form, password:e.target.value})}/>
            <button data-testid="login-submit" disabled={loading} className="btn-primary w-full justify-center">{loading? "Signing in…" : "Sign in"}</button>
          </form>
          <p className="text-sm text-gray-500 mt-8">New here? <Link to="/register" className="text-copper hover:text-[#A0834F]">Create account</Link></p>
          <p className="text-xs text-gray-400 mt-3">Staff member? <Link to="/staff/login" className="text-gray-700 hover:text-dark">Staff sign in →</Link></p>
        </div>
      </div>
    </div>
  );
}
